import { Pipe, PipeTransform } from '@angular/core';
import { PromotionType } from '@shared/enums/PromotionType';

@Pipe({
    name: 'promotionType'
})
export class PromotionTypePipe implements PipeTransform {
    transform(promotionType: PromotionType): string {
        let promotionLabel = '';

        switch (promotionType) {
            case PromotionType.FixedDiscount:
                promotionLabel = 'Fixed';
                break;
            case PromotionType.PercentageDiscount:
                promotionLabel = 'Percentage';
                break;
            case PromotionType.NewPrice:
                promotionLabel = 'New price';
                break;
            case PromotionType.Budget:
                promotionLabel = 'Budget';
                break;
        }

        return promotionLabel;
    }
}
